import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

import BirthdayBanner from './src/components/BirthdayBanner';

app.initializers.add('florcarioca/flarum-birthday', () => {
  // Mount birthday banner below the fixed header
  setTimeout(() => {
    const birthdays = app.forum.attribute('todayBirthdays') || [];

    if (birthdays.length > 0) {
      const bannerContainer = document.createElement('div');
      bannerContainer.id = 'birthday-banner';
      document.body.appendChild(bannerContainer);

      m.mount(bannerContainer, BirthdayBanner);

      document.body.classList.add('has-birthday-banner');

      requestAnimationFrame(() => {
        const height = bannerContainer.offsetHeight;
        document.body.style.setProperty('--birthday-banner-height', height + 'px');
      });
    }
  }, 0);

  // Add birthday field to settings page
  extend(SettingsPage.prototype, 'settingsItems', function (items) {
    const user = app.session.user;
    if (!user) return;

    // Convert YYYY-MM-DD (API) to DD/MM/YYYY (display)
    const toDisplay = (iso) => {
      if (!iso) return '';
      const [y, m, d] = iso.split('-');
      return `${d}/${m}/${y}`;
    };

    // Convert DD/MM/YYYY (display) to YYYY-MM-DD (API)
    const toIso = (display) => {
      if (!display) return '';
      const [d, m, y] = display.split('/');
      if (!d || !m || !y) return '';
      return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    };

    // Validate DD/MM/YYYY (also checks calendar validity)
    const isValidDate = (display) => {
      if (!display) return true;
      const match = display.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!match) return false;
      const d = parseInt(match[1], 10);
      const mo = parseInt(match[2], 10);
      const y = parseInt(match[3], 10);
      if (mo < 1 || mo > 12 || d < 1 || d > 31) return false;
      const date = new Date(y, mo - 1, d);
      return date.getFullYear() === y && date.getMonth() === mo - 1 && date.getDate() === d;
    };

    if (!this._birthday) {
      this._birthday = Stream(toDisplay(user.attribute('birthday')));
      this._birthdayError = Stream(false);
      this._birthdaySaving = false;
      this._birthdayDirty = false;
      this._datePickerRef = null;
    }

    const validate = (val) => this._birthdayError(val !== '' && !isValidDate(val));

    const saveBirthday = () => {
      this._birthdaySaving = true;

      user
        .save({ birthday: toIso(this._birthday()) || null })
        .then(() => {
          this._birthdaySaving = false;
          this._birthdayDirty = false;
          m.redraw();
        })
        .catch(() => {
          this._birthdaySaving = false;
          m.redraw();
        });
    };

    items.add(
      'birthday',
      <div className="BirthdaySection">
        <h3>
          <i className="fas fa-birthday-cake"></i>
          {' '}
          {app.translator.trans('florcarioca-birthday.forum.settings.section_title')}
        </h3>

        <div className="Form-group">
          <label>{app.translator.trans('florcarioca-birthday.forum.settings.birthday_label')}</label>
          <div className="BirthdayInput">
            <input
              className={'FormControl' + (this._birthdayError() ? ' is-error' : '')}
              type="text"
              placeholder="JJ/MM/AAAA"
              value={this._birthday()}
              oninput={(e) => {
                this._birthday(e.target.value);
                this._birthdayDirty = true;
                validate(e.target.value);
              }}
              onblur={(e) => validate(e.target.value)}
            />
            <button
              type="button"
              className="Button BirthdayCalendarBtn"
              title="Choisir une date"
              onclick={() => this._datePickerRef && this._datePickerRef.showPicker()}
            >
              <i className="fas fa-calendar-alt" />
            </button>
            <input
              type="date"
              className="BirthdayHiddenPicker"
              value={toIso(this._birthday())}
              oncreate={(vnode) => { this._datePickerRef = vnode.dom; }}
              onchange={(e) => {
                const display = toDisplay(e.target.value);
                this._birthday(display);
                this._birthdayDirty = true;
                this._birthdayError(false);
                m.redraw();
              }}
            />
          </div>
          {this._birthdayError() && (
            <p className="helpText BirthdayError">
              <i className="fas fa-exclamation-circle" /> Format invalide — utilisez JJ/MM/AAAA
            </p>
          )}
          <p className="helpText">
            {app.translator.trans('florcarioca-birthday.forum.settings.birthday_help')}
          </p>
        </div>

        {Button.component(
          {
            className: 'Button Button--primary',
            loading: this._birthdaySaving,
            disabled: !this._birthdayDirty || this._birthdayError(),
            onclick: saveBirthday,
          },
          app.translator.trans('florcarioca-birthday.forum.settings.save')
        )}
      </div>,
      95
    );
  });
});
